import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFrasesConfirmacionThunk } from "../store/reducers/frasesConfirmacion/frasesConfirmacion.thunks";
import FrasesConfirmacionHeader from "../components/frasesConfirmacion/FrasesConfirmacionHeader";
import FrasesConfirmacionTable from "../components/frasesConfirmacion/FrasesConfirmacionTable";
import FraseConfirmacionViewModal from "../components/frasesConfirmacion/FraseConfirmacionViewModal";
import ConfirmToggleModal from "../components/frasesConfirmacion/ConfirmToggleModal";
import FraseConfirmacionFormModal from "../components/frasesConfirmacion/FraseConfirmacionFormModal";
import Loader from "../components/UI/Loader";
import Alert from "../components/UI/Alert";
import Pagination from "../components/UI/Pagination";
import {
  clearFrasesConfirmacionError,
  setPage,
} from "../store/reducers/frasesConfirmacion/frasesConfirmacion.reducer";
import EmptyState from "./UI/EmptyState";
import { Icon } from "@iconify/react";

const FrasesConfirmacionListLayer = () => {
  const dispatch = useDispatch();
  const {
    list,
    loading,
    error,
    page,
    pageSize,
    search,
    talentoFilter,
    preguntaFilter,
    count,
  } = useSelector((state) => state.frasesConfirmacion);

  useEffect(() => {
    dispatch(
      getFrasesConfirmacionThunk({
        page,
        search,
        talento: talentoFilter,
        pregunta: preguntaFilter,
      })
    );
  }, [dispatch, page, search, talentoFilter, preguntaFilter]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <FrasesConfirmacionHeader />

        {/* ERROR */}
        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearFrasesConfirmacionError())}
          />
        )}

        {/* LOADING */}
        {loading ? (
          <Loader center text="Cargando frases..." delay={200} />
        ) : (
          <>
            {/* INFO DE BÚSQUEDA */}
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {/* EMPTY / TABLE */}
            {list.length === 0 ? (
              <EmptyState
                icon={
                  search || talentoFilter || preguntaFilter
                    ? "mdi:magnify-remove-outline"
                    : "mdi:format-quote-close"
                }
                title={
                  search || talentoFilter || preguntaFilter
                    ? "No se encontraron frases"
                    : "No hay frases registradas"
                }
                description={
                  search || talentoFilter || preguntaFilter
                    ? "Intenta con otra búsqueda o filtros"
                    : "Comienza agregando una nueva frase"
                }
              />
            ) : (
              <>
                <FrasesConfirmacionTable frases={list} search={search} />

                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </>
        )}
      </div>

      {/* MODALES */}
      <FraseConfirmacionViewModal />
      <FraseConfirmacionFormModal />
      <ConfirmToggleModal />
    </div>
  );
};

export default FrasesConfirmacionListLayer;
